var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DialogEx',{attrs:{"options":_vm.dialogOptions,"title":_vm.fileName}},[_c('div',{staticStyle:{"width":"100%","height":"70vh","background":"#fff"}},[(_vm.previewUrl)?_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"none"},attrs:{"src":_vm.previewUrl,"frameborder":"0"}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }